import { SimpleOptionType } from 'types/filters';

export const mapStatesResponse = (
  response: Record<string, string>[] | Record<string, string>
): SimpleOptionType[] => {
  const merged: Record<string, string> = Array.isArray(response)
    ? (Object.assign({}, ...response) as Record<string, string>)
    : response;

  return Object.entries(merged).map(([value, label]) => ({
    label,
    value,
    key: value
  }));
};

export const mapCitiesResponse = (response: string[]): SimpleOptionType[] =>
  response.map((city) => ({
    label: city,
    value: city,
    key: city
  }));
